var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { ItemBase } from '../../../../models/item/item-base';
var KtsSupervisorComponent = /** @class */ (function (_super) {
    __extends(KtsSupervisorComponent, _super);
    function KtsSupervisorComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.items = {};
        return _this;
    }
    KtsSupervisorComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.items = {};
        this.col = Object.assign(new ItemBase(), {
            controlType: 'select',
            label: this.msgSnapshot['au.COMPONENT.KtsSupervisorComponent.label.construction_supervisor'],
            key: 'construction_supervisor_m_id',
            params: { options: [] }
        });
        this.setCompRec();
    };
    KtsSupervisorComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsSupervisorComponent.prototype.onSubscribe = function (data) {
        if (typeof data[this.col.key] !== 'undefined') {
            this.items[this.col.key] = data[this.col.key];
        }
        else if (typeof data.items !== 'undefined' && data.items instanceof Array) {
            delete this.col;
            this.col = Object.assign(new ItemBase(), {
                controlType: 'select',
                label: this.msgSnapshot['au.COMPONENT.KtsSupervisorComponent.label.construction_supervisor'],
                key: 'construction_supervisor_m_id',
                params: { options: [] }
            });
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.id, display: item.name });
            }
            this.col.params.options = options;
        }
        this.setCompRec();
    };
    KtsSupervisorComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    KtsSupervisorComponent.prototype.onChange = function (e) {
        this.items[e.key] = e.val;
        this.setCompRec();
    };
    KtsSupervisorComponent.prototype.setCompRec = function () {
        this.action.setCompRec(this.componentName, this.items);
    };
    KtsSupervisorComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-supervisor',
                    template: "<form id=\"{{ componentName }}\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"items\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsSupervisorComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return KtsSupervisorComponent;
}(ContentBaseComponent));
export { KtsSupervisorComponent };
//# sourceMappingURL=supervisor.component.js.map